import httpsV2 from '../config/httpsV2'

export const paymentSuccess = (body) => {
    return httpsV2.post('/payment-success', body)
}

export const paymentSuccessPatch = (body) => {
    return httpsV2.patch('/payment-success', body)
}

export const _bulkPurchase = (body) => {
    return httpsV2.post('/bulk-tickets', body)
}

export const _addToMailingList = (body) => {
    return httpsV2.post('/mailing-list', {
        ...body,
        path: "add-to-mailing-list"
    })
}

export const _contactUs = (body) => {
    return httpsV2.post('/contact-us', {
        ...body,
        path: "contact-us"
    })
}

export const _getMailingList = (body) => {
    return httpsV2.post('/mailing-list', {
        ...body,
        path: "get-mailing-list"
    })
}

export const _getUserHistory = (body) => {
    return httpsV2.post('/user-history', {
        ...body,
        path: "get-user-history"
    })
}

export const _login = (body) => {
    return httpsV2.post('/user', body)
}

export const getAllPurchases = () => {
    return httpsV2.get('/all-payments')
}
export const getTickets = () => {
    return httpsV2.get('/tickets')
}